export const enum TripOverviewPanelType {
  None = 'none',
  Configuration = 'configuration',
  FerryFilters = 'ferryFilters',
  TripPriceSummary = 'tripPriceSummary',
  HotelFilters = 'hotelFilters',
  FlightsFilters = 'flightsFilters',
}

export interface TripOverviewNoPanel {
  type: TripOverviewPanelType.None;
}

export interface TripOverviewConfigurationPanel {
  type: TripOverviewPanelType.Configuration;
}

export interface TripOverviewFerryFiltersPanel {
  type: TripOverviewPanelType.FerryFilters;
}

export interface TripOverviewTripPriceSummaryPanel {
  type: TripOverviewPanelType.TripPriceSummary;
}

export interface TripOverviewHotelFiltersPanel {
  type: TripOverviewPanelType.HotelFilters;
}

export interface TripOverviewFlightsFiltersPanel {
  type: TripOverviewPanelType.FlightsFilters;
}

export type TripOverviewPanel =
  | TripOverviewNoPanel
  | TripOverviewConfigurationPanel
  | TripOverviewFerryFiltersPanel
  | TripOverviewTripPriceSummaryPanel
  | TripOverviewFlightsFiltersPanel
  | TripOverviewHotelFiltersPanel;

export const TRIP_OVERVIEW_NO_PANEL: TripOverviewNoPanel = {
  type: TripOverviewPanelType.None,
};

export const TRIP_OVERVIEW_CONFIGURATION_PANEL: TripOverviewConfigurationPanel =
  {
    type: TripOverviewPanelType.Configuration,
  };

export const TRIP_OVERVIEW_FERRY_FILTERS_PANEL: TripOverviewFerryFiltersPanel =
  {
    type: TripOverviewPanelType.FerryFilters,
  };
export const TRIP_OVERVIEW_NEW_TRIP_PRICE_SUMMARY_PANEL: TripOverviewTripPriceSummaryPanel =
  {
    type: TripOverviewPanelType.TripPriceSummary,
  };

export const TRIP_OVERVIEW_HOTEL_FILTERS_PANEL: TripOverviewHotelFiltersPanel =
  {
    type: TripOverviewPanelType.HotelFilters,
  };

export const TRIP_OVERVIEW_FLIGHTS_FILTERS_PANEL: TripOverviewFlightsFiltersPanel =
  {
    type: TripOverviewPanelType.FlightsFilters,
  };
